import { Injectable } from "@angular/core";
import { PlayerTypePrice } from "./price.types";
import { HttpClient, HttpParams } from "@angular/common/http";
import { SnackbarService } from "app/core/snackbars/snackbar.service";
import { catchError, Observable } from "rxjs";

@Injectable()
export class PriceService {
  constructor(
    private _httpClient: HttpClient,
    private _snackbarService: SnackbarService,
  ) {
  }

  getPlayerTypePrice(playerTypeId: number, date: string): Observable<PlayerTypePrice> {
    const params = new HttpParams()
      .set('PlayerTypeId', playerTypeId)
      .set('Date', date);

    return this._httpClient.get<PlayerTypePrice>(`api/Prices/Player-Type/Price`, { params }).pipe(
      catchError((err, _) => {
        this._snackbarService.error(err);
        throw err;
      })
    );
  }
}